import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["id", "children", "title", "description", "titleSectionSize", "titleTag", "tabBarItems", "filterItems", "moreButton", "className", "pagination", "backgroundColor", "layoutType", "titleAlign"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { useState } from 'react';
import { useLocale } from '@sbercloud/uikit-product-locale';
import { AdaptiveFieldSelect } from '@sbercloud/uikit-product-mobile-fields';
import { Layout } from '@sbercloud/uikit-product-site-layout';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { ButtonOutline } from '@snack-uikit/button';
import { Pagination } from '@snack-uikit/pagination';
import { Tabs } from '@snack-uikit/tabs';
import { SECTION_COLORS } from '../../constants';
import { SectionTitle } from '../../helperComponents';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var getInitialTab = function getInitialTab(tabBarItems) {
  if (!tabBarItems || tabBarItems.length < 1) {
    return undefined;
  }
  var _tabBarItems = _slicedToArray(tabBarItems, 1),
    firstTab = _tabBarItems[0];
  return firstTab.value;
};
export function SectionBasic(_ref) {
  var _moreButton$label, _moreButton$dataTest;
  var id = _ref.id,
    children = _ref.children,
    title = _ref.title,
    description = _ref.description,
    _ref$titleSectionSize = _ref.titleSectionSize,
    titleSectionSize = _ref$titleSectionSize === void 0 ? 'm' : _ref$titleSectionSize,
    titleTag = _ref.titleTag,
    tabBarItems = _ref.tabBarItems,
    filterItems = _ref.filterItems,
    moreButton = _ref.moreButton,
    className = _ref.className,
    pagination = _ref.pagination,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? SECTION_COLORS.NeutralBackground1Level : _ref$backgroundColor,
    layoutType = _ref.layoutType,
    titleAlign = _ref.titleAlign,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(getInitialTab(tabBarItems)),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  var _useLocale = useLocale('SiteSection'),
    t = _useLocale.t;
  var showFooter = Boolean(pagination || moreButton);
  return /*#__PURE__*/_jsx(Layout.SectionWrapper, _objectSpread(_objectSpread({
    id: id,
    layoutType: layoutType,
    className: cn(className, styles.wrapper),
    "data-section-background": backgroundColor
  }, extractSupportProps(rest)), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.sectionBasic,
      "data-layout-type": layoutType,
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        layoutType: layoutType,
        title: title,
        description: description,
        titleSectionSize: titleSectionSize,
        titleTag: titleTag,
        titleAlign: titleAlign
      }), (tabBarItems === null || tabBarItems === void 0 ? void 0 : tabBarItems.length) && /*#__PURE__*/_jsx("div", {
        className: styles.sectionTabs,
        children: /*#__PURE__*/_jsx(Tabs, {
          value: currentTab,
          onChange: setCurrentTab,
          children: /*#__PURE__*/_jsx(Tabs.TabBar, {
            children: tabBarItems.map(function (tabProps) {
              return /*#__PURE__*/_jsx(Tabs.Tab, _objectSpread({}, tabProps), tabProps.value);
            })
          })
        })
      }), (filterItems === null || filterItems === void 0 ? void 0 : filterItems.length) && /*#__PURE__*/_jsx("div", {
        className: styles.sectionFilters,
        "data-layout-type": layoutType,
        children: filterItems.map(function (filterProps) {
          return /*#__PURE__*/_jsx(AdaptiveFieldSelect, _objectSpread(_objectSpread({}, filterProps), {}, {
            className: cn(filterProps.className, styles.filter),
            layoutType: layoutType,
            size: "l"
          }), filterProps.id);
        })
      }), children, showFooter && /*#__PURE__*/_jsxs("div", {
        className: styles.footer,
        "data-layout-type": layoutType,
        children: [pagination && /*#__PURE__*/_jsx(Pagination, _objectSpread({}, pagination)), moreButton && /*#__PURE__*/_jsx(ButtonOutline, {
          className: styles.showMoreButton,
          label: (_moreButton$label = moreButton.label) !== null && _moreButton$label !== void 0 ? _moreButton$label : t('Basic.showMore'),
          onClick: moreButton.onClick,
          href: moreButton.href,
          "data-test-id": (_moreButton$dataTest = moreButton['data-test-id']) !== null && _moreButton$dataTest !== void 0 ? _moreButton$dataTest : 'section__more-btn',
          appearance: "neutral",
          size: "l",
          type: "button",
          "data-layout-type": layoutType
        })]
      })]
    })
  }));
}